// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./vue-material.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("4d340f30", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-material/dist/vue-material.css
// module id = 494
// module chunks = 0